import {
  Identifiable,
  Project,
  ProjectResource,
  Role,
  role as roleMock,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { ListedResource, toListedResource } from "../utils/resourcesListing";

type ListedMember = {
  uuid: string;
  role: { uuid: string; name: string } | null;
  deactivated: boolean | null;
  resource: ListedResource;
};

function toProjectMember(
  member: ListedMember,
  project: Identifiable<Project>,
): Identifiable<ProjectResource> {
  return {
    uuid: member.uuid,
    project,
    // A material member has no role, like with the details projection.
    role: (member.role
      ? { ...roleMock, uuid: member.role.uuid, name: member.role.name }
      : null) as Identifiable<Role>,
    deactivated: member.deactivated ?? false,
    resource: toListedResource(member.resource),
  };
}

// The back adds every activated planzone resource that isn't a member yet, and answers the added members.
function saveEveryoneInProject(httpClient: HttpClient) {
  return (project: Identifiable<Project>, role: Identifiable<Role>) =>
    httpClient
      .sendHttpRequest<ListedMember[]>({
        endpoint: "/projectMembers/everyone",
        method: HttpMethods.POST,
        data: { projectUuid: project.uuid, roleUuid: role.uuid },
      })
      .then((members) =>
        members.map((member) => toProjectMember(member, project)),
      );
}

export type { ListedMember };

export { saveEveryoneInProject, toProjectMember };
